import * as React from 'react';
import styled from 'styled-components';

import { Caption } from '../blog/Caption';

const Wrapper = styled.div<{ $height: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0px;
  position: relative;
  min-height: ${({ $height }) => ($height ? $height : '610px')};
  flex: 1 1 auto;
  margin-bottom: 20px;
`;

interface HexEmbedProps {
  caption?: string;
  height: string;
  src: string;
}

const EMBED_QUERY_PARAM = '?embedded=true';

export const HexEmbed: React.ComponentType<HexEmbedProps> = React.memo(
  ({ caption, src, height }) => {
    const embedSrc = !src.includes(EMBED_QUERY_PARAM)
      ? src + EMBED_QUERY_PARAM
      : src;

    return (
      <>
        <Wrapper $height={height}>
          <iframe
            allowFullScreen={true}
            frameBorder="0"
            src={embedSrc}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }}
            title="Hex embed"></iframe>
        </Wrapper>
        {caption && <Caption>{caption}</Caption>}
      </>
    );
  }
);
